export default number => {
    return Math.floor(Number(number) / 1000).toLocaleString();
};